export const resolveIsChiefComplaint = () => {
    return {
        output_type: 'boolean',
        type: 'is-chief-complaint-condition',
    };
};
//# sourceMappingURL=is-chief-complaint.js.map